import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { SourceService } from '../source.service';
import { helper } from 'src/environments/helper';
import { AddSource } from '../source';
@Component({
    selector: 'app-add-source',
    templateUrl: './add-source.component.html',
    styleUrls: ['./add-source.component.scss'],
})
export class AddSourceComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        name: new FormControl('', Validators.required),
        color: new FormControl('', Validators.required),
        slug: new FormControl('', Validators.required),
    });

    constructor(
        private dialogRef: MatDialogRef<AddSourceComponent>,
        private sourceService: SourceService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.sourceService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, color, slug } = this.form.value as AddSource;

        const newSource: AddSource = {
            name,
            color,
            slug,
        };

        this.sourceService
            .addSurse(newSource)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let errorMessage = err.error.errors.message;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }
}
